//      
                                                                       

export function tryGetDestination(impact            )                     {
  if (impact.at && impact.at.type === 'REORDER') {
    return impact.at.destination;
  }
  return null;
}

export function tryGetCombine(impact            )           {
  if (impact.at && impact.at.type === 'COMBINE') {
    return impact.at.combine;
  }
  return null;
}



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/get-impact-location.js